import { formatDate } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { BaseDatepickerService } from '../services/base-datepicker.service';

@Pipe({
  name: 'cerrixDate',
  standalone: true,
  pure: true,
})
export class CerrixDatePipe implements PipeTransform {
  private static readonly defaultFormat: string = 'dd-MM-yyyy';
  private static readonly defaultFormatWithTime: string = `${CerrixDatePipe.defaultFormat} HH:mm`;

  private readonly defaultLocale: string = inject(LOCALE_ID);
  private readonly dateService = inject(BaseDatepickerService, {
    optional: true,
  });

  transform(
    date: Date | null | undefined,
    hasTime: boolean = false
  ): string | null {
    let result: string | null = null;

    if (date) {
      if (this.dateService) {
        result = formatDate(
          date,
          this.dateService.getDateFormat(),
          this.dateService.getLocale()
        );
      } else {
        result = formatDate(
          date,
          hasTime
            ? CerrixDatePipe.defaultFormatWithTime
            : CerrixDatePipe.defaultFormat,
          this.defaultLocale
        );
      }
    }

    return result;
  }
}
